<template>
  <v-card>
    <v-card-title primary-title>
      <h3 class="headline mb-0">Credit cards</h3>
    </v-card-title>

    <v-card-text v-if="showError">
      <v-alert v-model="showError" type="error" icon="warning" dismissible>{{ errorMessage }}</v-alert>
    </v-card-text>

    <v-card-text v-if="showInfo">
      <v-alert v-model="showInfo" type="info" icon="info" dismissible>{{ infoMessage }}</v-alert>
    </v-card-text>

    <v-card-text>
      <v-list>
        <template v-for="(stripePaymentMethod, index) in payments.stripePaymentMethods">
          <v-list-tile
          :key="stripePaymentMethod.id">
            <v-list-tile-content :key="index">
              <v-list-tile-title v-text="stripePaymentMethod.card"></v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-btn
              icon
              color="primary"
              :loading="isUpdatingPayment"
              :disabled="isUpdatingPayment"
              @click.stop="selectedCreditCard = stripePaymentMethod; dialogRemove = true;">
              <!-- @click="removeCreditCard(stripePaymentMethod.id)"> -->
                <v-icon>delete</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
        </template>

        <!-- <v-divider></v-divider> -->

        <v-list-tile>
          <v-list-tile-content>
            <v-list-tile-title>
              <div ref="stripeCard" class="stripe-element"></div>
            </v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-btn
            icon
            color="primary"
            :loading="isUpdatingPayment"
            :disabled="isUpdatingPayment"
            @click="addCreditCard()">
              <v-icon>add</v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>

      </v-list>
    </v-card-text>

    <v-dialog
    v-model="dialogRemove"
    width="500">
      <v-card>
        <v-card-title
        class="headline grey lighten-2"
        primary-title
        >Remove Credit Card?</v-card-title>
        <v-card-text v-if="selectedCreditCard">
          Are you sure you want to remove the credit card "{{ selectedCreditCard.card }}" permanently?
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
          color="primary"
          flat
          @click="dialogRemove = false"
          >Cancel</v-btn>
          <v-btn
          color="primary"
          flat
          @click="removeCreditCard"
          >Remove</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
// import { auth } from '@/firebase.js';
import { stripe } from '@/firebase.js'
import { createNamespacedHelpers } from "vuex";
// const namespacedHelperUsersAuth = createNamespacedHelpers("auth");
// const mapStateAuth = namespacedHelperUsersAuth.mapState;
const { mapState, mapActions } = createNamespacedHelpers("pay");

export default {
  name: "CreditCard",

  mixins: [],

  mounted: function () {
    this.stripeElements = stripe.elements();
    const style = {
      base: {
        color: '#000'
      },
      invalid: {
      }
    }
    this.stripeCard = this.stripeElements.create('card', {style});
    this.stripeCard.mount(this.$refs.stripeCard);
  },

  data() {
    return {
      debug: false,

      stripeElements: null,
      stripeCard: null,

      dialogRemove: false,
      selectedCreditCard: null,
      selectedCreditCardIndex: null,

      showError: false,
      errorMessage: "",

      showInfo: false,
      infoMessage: ""
    };
  },

  props: {},

  watch: {},

  computed: {
    // user() {
    //   return this.$store.state.auth.user;
    // },

    ...mapState({
      isUpdatingPayment: state => state.isUpdatingPayment, // map `this.isUpdatingPayment` to `this.$store.state.pay.isUpdatingPayment`
      payments: state => state.payments, // map `this.payments` to `this.$store.state.pay.payments`
    }),

  },

  methods: {
    ...mapActions([
      'addStripeCreditCard', // map `this.addStripeCreditCard(card)` to `this.$store.dispatch('pay/addStripeCreditCard', card)`
      'removeStripeCreditCard' // map `this.removeStripeCreditCard(paymentMethodId)` to `this.$store.dispatch('pay/removeStripeCreditCard', paymentMethodId)`
    ]),

    addCreditCard () {
      if (this.debug) console.log(this.$options.name + ".addCreditCard()");
      this.addStripeCreditCard(this.stripeCard)
      .then(() => {
        if (this.debug) console.log(this.$options.name+'.addCreditCard() credid card added')
        this.showError = false
        this.stripeCard.clear();
      })
      .catch((error) => {
        if (this.debug) console.log(this.$options.name+'.addCreditCard() error['+(typeof error)+']:',error)
        this.errorMessage = error
        this.showError = true
      })
    },

    // removeCreditCard (paymentMethodId) {
    removeCreditCard () {
      this.dialogRemove = false;
      // if (this.debug) console.log(this.$options.name + ".removeCreditCard() paymentMethodId:", paymentMethodId);
      if (this.debug) console.log(this.$options.name + '.removeCreditCard() selectedCreditCard:', this.selectedCreditCard);
      if (this.selectedCreditCard) {
        if (this.debug) console.log(this.$options.name + '.removeCreditCard() selectedCreditCard.id:', this.selectedCreditCard.id);
        // this.removeStripeCreditCard(paymentMethodId)
        this.removeStripeCreditCard(this.selectedCreditCard.id)
        .then(() => {
          if (this.debug) console.log(this.$options.name+'.removeCreditCard() credid card removed')
          this.showError = false;
          this.selectedCreditCard = null;
        })
        .catch((error) => {
          if (this.debug) console.log(this.$options.name+'.removeCreditCard() error['+(typeof error)+']:',error)
          this.errorMessage = error;
          this.showError = true;
          this.selectedCreditCard = null;
        })
      }
    }

  }
};
</script>

<style scoped> /* "scoped" attribute limit the CSS to this component only */
/* .stripe-element {
  border: 1px solid #D8D8D8;
  border-radius: 4px;
} */

</style>